import(/* webpackMode: "eager", webpackExports: ["CookiePreferencesLink"] */ "/opt/buildhome/repo/components/cookie/CookiePreferencesLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClosureNoticeClient"] */ "/opt/buildhome/repo/components/layout/ClosureNoticeClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/opt/buildhome/repo/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageToggleLink"] */ "/opt/buildhome/repo/components/layout/LanguageToggleLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainLayoutClient"] */ "/opt/buildhome/repo/components/layout/MainLayoutClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsletterSignup"] */ "/opt/buildhome/repo/components/layout/NewsletterSignup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SocialLink"] */ "/opt/buildhome/repo/components/SocialLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/opt/buildhome/repo/components/ui/separator.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/image-component.js");
